// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-bar-container {
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 8px;
  overflow: hidden;
}
.progress-bar-container .progress-bar-fill {
  position: absolute;
  left: 0;
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 0 8px 8px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/colored-progress-bar/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,OAAA;EACA,YAAA;EACA,2BAAA;EACA,0BAAA;AACJ","sourcesContent":[".progress-bar-container {\n  position: relative;\n  width: 100%;\n  height: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n\n  .progress-bar-fill {\n    position: absolute;\n    left: 0;\n    height: 100%;\n    transition: width 0.3s ease;\n    border-radius: 0 8px 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
